import React, {useEffect, useRef} from 'react';
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import {activateUser, clearFailedLogin, waitForLogin} from './../../../state/actions/authActions';
import {Card, CardContent, Typography,} from '@material-ui/core';
import LoadingCircle from "../../util/common/LoadingCircle";

function ActivateUserPage(props) {
  const activated = useRef(false);
  const failedActivation = useRef(false);
  const token = props.match.params.token;

  useEffect(() => {
    if(!activated.current){
      return;
    }
    if (props.isLoggedIn) {
      if(props.resetPassword){
        props.history.push("/settings")
      }else{
        props.history.push('/explore')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isLoggedIn, activated.current]);

  useEffect(() => {
    props.clearFailedLogin();
    if(token.length !== 32 || !token.match(/^[0-9a-fA-F]+$/)){
      failedActivation.current = true;
      return;
    }
    if (props.isLoggedIn) {
      props.history.push('/explore')
    }
    activated.current = true;
    setTimeout(() => props.activateUser(token), 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{maxWidth: 400, margin: '0 auto', marginTop: 64}}>
      <Card style={{borderTop: '1px solid rgba(0,0,0,0.12)'}}>
        <CardContent>
          <h2 style={{fontWeight: '400', marginTop: 0}}>{props.failedLogin || failedActivation.current ? "Error " : null}Activating User</h2>
          {props.failedLogin || failedActivation.current ?
            <Typography id="activationError" color="textSecondary" gutterBottom style={{backgroundColor: '#ffbdbd', padding: '4px 8px', borderRadius: '4px'}}>
              { !!props.failedLoginMessage ? props.failedLoginMessage : failedActivation.current ? "Failed Invalid activation token." : null }
            </Typography>
            : null
          }
          {props.failedLogin || failedActivation.current ?
            <div>
              <a href="/v2/forgot-password">Reset password</a> to generate a new activation link.
            </div>
            : <div>
              <div>
                Your user account is being activated.  You will be redirected to <a href="/v2/explore">your mindfile</a> shortly.
              </div>
              <div style={{textAlign:"center", padding:"1rem"}}>
                <LoadingCircle size="small"/>
              </div>
            </div>
          }
        </CardContent>
      </Card>
    </div>
  )
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.uid,
  resetPassword: state.auth.redirect,
  failedLogin: state.auth.failedLogin,
  failedLoginMessage: state.auth.failedLoginMessage,

});

const mapDispatchToProps = {
  activateUser,
  waitForLogin,
  clearFailedLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActivateUserPage));